import * as React from 'react'
import { Defs, LinearGradient, Path, Stop } from 'react-native-svg'
import styled, { useTheme } from 'styled-components/native'

import { AccessibleSvg } from 'ui/svg/AccessibleSvg'
import { AccessibleIcon } from 'ui/svg/icons/types'
import { svgIdentifier } from 'ui/svg/utils'

const DiskSvg: React.FunctionComponent<AccessibleIcon> = ({
  size,
  color,
  color2,
  accessibilityLabel,
  testID,
}) => {
  const {
    colors: { primary, secondary },
  } = useTheme()
  const { id: gradientId, fill: gradientFill } = svgIdentifier()

  return (
    <AccessibleSvg
      width={size}
      height={size}
      viewBox="0 0 25 24"
      testID={testID}
      accessibilityLabel={accessibilityLabel}>
      <Defs>
        <LinearGradient id={gradientId} x1="0%" x2="100%" y1="13.494%" y2="86.506%">
          <Stop offset="0%" stopColor={color ?? primary} />
          <Stop offset="100%" stopColor={color2 ?? color ?? secondary} />
        </LinearGradient>
      </Defs>
      <Path
        fill={gradientFill}
        clipRule="evenodd"
        fillRule="evenodd"
        d="M17.655 4.10229C13.7652 1.33262 8.36757 2.24478 5.60258 6.13467L5.60225 6.13513C3.32776 9.3274 3.53608 13.5402 5.83496 16.4767V9.67858L6.73762 8.77161C6.43055 8.16472 6.53014 7.40273 7.03642 6.89645L7.82642 6.10645C8.45668 5.47619 9.48326 5.47619 10.1135 6.10645C10.7438 6.73672 10.7438 7.7633 10.1135 8.39356L9.32352 9.18356C8.81591 9.69117 8.05122 9.78996 7.44355 9.47991L6.83496 10.0914V18.89H7.45503C8.04117 18.89 8.51503 19.3639 8.51503 19.95V21.07C8.51503 21.6591 8.03327 22.13 7.45503 22.13H5.21503C4.62889 22.13 4.15503 21.6562 4.15503 21.07V19.95C4.15503 19.3639 4.62889 18.89 5.21503 18.89H5.83496V17.8666C5.74204 17.8447 5.65435 17.796 5.58436 17.721C2.5259 14.4411 2.08198 9.35276 4.78767 5.55508C7.87273 1.21516 13.895 0.197419 18.2351 3.28769C22.5745 6.37751 23.5928 12.3945 20.5024 16.7349C18.187 19.9891 14.2212 21.375 10.552 20.5632C10.2824 20.5035 10.1122 20.2366 10.1718 19.967C10.2315 19.6973 10.4984 19.5271 10.7681 19.5868C14.0589 20.3149 17.6131 19.0709 19.6876 16.1551L19.6877 16.155C22.4573 12.2654 21.5455 6.87244 17.655 4.10229ZM6.26417 19.89H5.21503C5.18117 19.89 5.15503 19.9162 5.15503 19.95V21.07C5.15503 21.1039 5.18117 21.13 5.21503 21.13H7.45503C7.46879 21.13 7.48391 21.1246 7.49694 21.1116C7.50954 21.0991 7.51503 21.0848 7.51503 21.07V19.95C7.51503 19.9162 7.48889 19.89 7.45503 19.89H6.40575C6.38263 19.8933 6.35899 19.895 6.33496 19.895C6.31093 19.895 6.2873 19.8933 6.26417 19.89ZM12.655 9.64001C11.8321 9.64001 11.165 10.3071 11.165 11.13C11.165 11.9529 11.8321 12.62 12.655 12.62C13.4779 12.62 14.145 11.9529 14.145 11.13C14.145 10.3071 13.4779 9.64001 12.655 9.64001ZM10.165 11.13C10.165 9.75483 11.2799 8.64001 12.655 8.64001C14.0302 8.64001 15.145 9.75483 15.145 11.13C15.145 12.5052 14.0302 13.62 12.655 13.62C11.2799 13.62 10.165 12.5052 10.165 11.13ZM8.53352 6.81356C8.77326 6.57382 9.16668 6.57382 9.40642 6.81356C9.64616 7.0533 9.64616 7.44672 9.40642 7.68645L8.61642 8.47645C8.37668 8.71619 7.98326 8.71619 7.74352 8.47646C7.50379 8.23672 7.50379 7.8433 7.74352 7.60356L8.53352 6.81356Z"
      />
    </AccessibleSvg>
  )
}

export const Disk = styled(DiskSvg).attrs(({ color, size, theme }) => ({
  color: color ?? theme.colors.black,
  size: size ?? theme.icons.sizes.standard,
}))``
